import React from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { translate, isNullOrEmpty } from '../../../../../utils/util';
import { VISIONS } from '../../../../../utils/constants';
import Breadcrumbs from '../../../../../components/UI/Breadcrumbs';
import ButtonUI from '../../../../../components/UI/ButtonUI';
import LinePickingService from '../../../../../services/LinePickingService';
import { getVision } from '../../../../../services/auth';
import Select from '../../../../../components/UI/Select';

const OrderWithOutRoute = (props) => {
    const item = props.order?.items ? props.order?.items[0] : {}
    const onConfirm = () => {
        const routeId = document.getElementById("routes").value;
        if (!isNullOrEmpty(routeId)) {
            props.changeRouteOrder(props.order.orderId, routeId, () => {
                props.history.go(-1);
            })
        }
    };

    const getOrderCode = (orderCode, orderItemCode) => {
        if (orderCode === '0000000000') {
            return `${translate('line-picking:linepicking.manual-order')} - ${orderItemCode || ''} `;
        }
        else if (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            return `${orderCode || ''} - ${orderItemCode || ''}`
        }
        return `${orderCode || ''}`;
    };

    return (
        <div>
            <Breadcrumbs id="routeUserInsert" title={{ icon: "mdi mdi-map-marker-off-outline", label: translate('line-picking:linepicking.without-route') }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px' }}>
                            <fieldset style={{ border: "1px solid #597dda" }}>
                                <legend style={{ padding: "0 5px" }}>
                                    {translate('route', 'route-picking')}
                                </legend>
                                <div className="row" style={{ marginBottom: '0' }}>
                                    <div className="col s12">
                                        <Select
                                            required
                                            id="routes"
                                            name="routes"
                                            display="description"
                                            defaultValue={""}
                                            placeHolder={translate('general:choose-one-option')}
                                            data={props.routes?.items ? props.routes.items.map((i) => { return { id: i.id, text: i.code }; }) : []}
                                        />
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset style={{ border: "1px solid #597dda" }}>
                                <legend style={{ padding: "0 2px" }}>
                                    {translate('expedition:picking.order')}
                                </legend>
                                <div className="row">
                                    <div className="input-field no-padding col s12">
                                        <span className="field f-1p5r">{getOrderCode(props.order.orderCode, item?.orderItemCode)}</span>
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <span className="field f-1r truncate">{item?.orderItemCode}</span>
                                        <label className="active" htmlFor="entryCode">{translate('line-picking:linepicking.material-code')}</label>
                                    </div>
                                    <div className="input-field no-padding col s4">
                                        <span className="field f-1r truncate">{item?.quantity}</span>
                                        <label className="active">{translate('line-picking:linepicking.amount')}</label>
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <span className="field f-1r">{item?.partnumber}</span>
                                        <label className="active">{translate('line-picking:linepicking.drawing')}</label>
                                    </div>
                                    <div className="input-field no-padding col s4">
                                        <span className="field f-1r truncate">{item?.location}</span>
                                        <label className="active">{translate('line-picking:linepicking.location')}</label>
                                    </div>
                                </div>
                            </fieldset>
                            <div className="row" style={{ paddingTop: "5px" }}>
                                <ButtonUI
                                    onClick={() => onConfirm()}
                                    full="true"
                                    text={translate("general:confirm")}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        routes: state.pickingReducer.routes,
        order: state.linePickingReducer.order
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeRouteOrder: (orderId, routeId, callback) => {
            dispatch(LinePickingService.changeRouteOrder(orderId, routeId, callback))
        }
    };
}; export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OrderWithOutRoute)));
